<template>
<div style="margin-left: 5px">
    <v-row class="pa-3">
        <div v-if="type === 'record'">
            Аудиоролик для рассылки
        </div>
        <div v-if="type === 'repeatRecord'">
            Аудиоролик для повтора
        </div>
    </v-row>
    <v-row>
        <v-select
            outlined
            v-model="source"
            :items="sources"
            item-text="name"
            item-value="type"
            label="Источник аудиоролика"
            persistent-hint
            @change="changeType()"
        ></v-select>
    </v-row>
    <v-row v-if="source === 'text'">
        <v-col cols="12">
            <v-switch
                v-model="gender"
                true-value="1"
                false-value="0"
                :label="gender===0 ? 'Женский голос' : 'Мужской голос'"
                @change="changeType()"
            ></v-switch>
        </v-col>
        <v-col cols="12">
            <v-textarea
                outlined
                v-model="text_for_generation"
                @blur="changeType()"
            ></v-textarea>
        </v-col>
    </v-row>
    <v-row v-if="source === 'saved'">
        <v-col cols="6">
            <p class="text-field-header">Выбор аудиоролика</p>
            <b-field>
                <b-autocomplete
                  :value="selected_audio.name"
                  clearable
                  :data="audioSaved"
                  :keep-first="false"
                  :open-on-focus="true"
                  field="name"
                  @input="option => onAudioInput(option)"
                  @select="option => setAudio(option)">
                  <template #empty> Нет результатов </template>
                </b-autocomplete>
            </b-field>
            <audio v-if="selected_audio.id && savedAudio" controls :src="savedAudio.find(element => element.id === selected_audio.id).path"></audio>
        </v-col>
    </v-row>
</div>
</template>

<script>
export default {
    name: "audioElement",
    props: [
        "element",
        "type",
        "account_mailer_id"
    ],
    data() {
        return {
            source: null,
            sources: [
                {
                    name: 'Сохраненные',
                    type: 'saved'
                },
                {
                    name: 'Текст',
                    type: 'text'
                },
            ],
            selected_audio: {
                name: '',
            },
            text_for_generation: '',
            gender: 0,
        }
    },
    created() {
        if (this.element.hasOwnProperty(this.type)) {
            if (this.element[this.type].hasOwnProperty("id")) {
                this.source = 'saved';
                this.selected_audio = this.savedAudio.find(element => element.id === this.element[this.type].id)
            }
            if (this.element[this.type].hasOwnProperty("text")) {
                this.source = 'text';
                this.text_for_generation = this.element[this.type].text;
                this.gender = this.element[this.type].gender;
            }
        } else {
            this.source = this.sources[0].type;
        }
        this.$store.dispatch('GET_RECORDS');
    },
    computed: {
        savedAudio() {
            return (this.$store.getters.RECORDS.results || []);
        },
      audioSaved() {
        return this.savedAudio.filter(
          (t) =>
            t.name.toLowerCase().includes(
              this.selected_audio.name.toLowerCase()
            )
        );
      },
    },
    methods: {
        changeType() {
            if (!this.element.hasOwnProperty(this.type)) {
                delete this.element[this.type]
            }
            switch (this.source) {
                case 'saved':
                        this.element[this.type] = {
                            "id": this.selected_audio.id,
                        }
                    break;
                case 'text':
                        this.element[this.type] = {
                            "text": this.text_for_generation,
                            "gender": this.gender,
                        }
                    break;

                default:
                    break;
            }
            this.element.ivrs.push();
        },
        setAudio(option) {
        if (option) {
          this.selected_audio = option;
        } else {
          this.selected_audio = { name: '' }; // или пустой объект {}
        }
      },
      onAudioInput(value) {
        if (!value) {
          // обнуляем весь объект при очистке
          this.selected_audio = { name: '' };
        } else {
          // если нужно оставить ввод в поле
          this.selected_audio.name = value;
        }
      },
    }
}
</script>

<style>

</style>
